<script lang="ts">
  import Dropdown from '$shared/atoms/Dropdown/Dropdown.svelte';
  import Input from '$shared/atoms/Input/Input.svelte';
  import InputGroup from '$shared/atoms/InputGroup/InputGroup.svelte';
  import type { CustomDropdownOption } from '$shared/components/types';
  import { onMount } from 'svelte';

  const DefaultCustomLabel = 'Add new item';

  const CustomListItem: CommonList = {
    id: 'custom',
    label: `Custom (${DefaultCustomLabel})`
  };

  interface Props {
    loading?: boolean;
    disabled?: boolean;
    options: CustomDropdownOption;
    onchange?: (item: CommonList) => void;
  }

  let { loading = false, disabled = false, options, onchange }: Props = $props();
  export const setValue = (value: string): void => {
    setInitialInputValue(value);
  };

  let list: CommonList[] = $state([]);
  let customSelectedLabel = $state('');
  let showCustomInput = $state(false);
  let initialValue = $state('');

  let parsedCustomLabel = $derived(
    options.createLabel ? `Custom (${options.createLabel})` : DefaultCustomLabel
  );

  onMount(() => {
    list = [...(options?.list || [])];

    let customItem = { ...CustomListItem, label: parsedCustomLabel };
    list.push(customItem);
  });

  const validateCustomValue = (value: string): void => {
    const isCustom = !list.find((item) => item.label === value);
    if (!isCustom) {
      initialValue = '';
      return;
    }
    isCustom && selectCustomOption();
  };

  const selectCustomOption = (): void => {
    showCustomInput = true;
    customSelectedLabel = parsedCustomLabel;
  };

  const resetCustomOption = (): void => {
    customSelectedLabel = '';
    showCustomInput = false;
  };

  const setInitialInputValue = (value: string): void => {
    initialValue = value;
    validateCustomValue(value);
  };

  const dispatchChange = (item: CommonList): void => {
    onchange?.(item);
  };

  const onChangeDropdown = (item: CommonList): void => {
    if (item.id === CustomListItem.id) {
      selectCustomOption();
      dispatchChange({ label: initialValue });
      return;
    }
    resetCustomOption();
    dispatchChange(item);
  };

  const onInputChange = (detail: any): void => {
    dispatchChange({ label: detail.value.trim() });
  };
</script>

<div class="comp-custom-dropdown">
  <Dropdown
    islarge
    {loading}
    {disabled}
    {list}
    label={customSelectedLabel || options?.label}
    maxWidth={options?.maxWidth}
    name={options?.name}
    onchange={onChangeDropdown}
  />

  {#if showCustomInput}
    <div class="input-wrap">
      <InputGroup columns={1}>
        <Input
          {disabled}
          name="custom-dropdown-name"
          value={initialValue}
          placeholder={options?.createLabel || DefaultCustomLabel}
          oninput={onInputChange}
        />
      </InputGroup>
    </div>
  {/if}
</div>

<style src="./CustomDropdown.css">
</style>
